import * as React from 'react';

import { useUpdateMyPresence } from '@liveblocks/react';
import { P16 } from '../Typography';
import { USERS } from '../../../providers/users';
import { useLiveCursors, COLORS } from './useLiveCursors';
import { useCursorConnections } from '../LiveBlockNotification/notification-store';

interface Cords {
  x: number;
  y: number;
}

interface CursorProps extends Cords {
  color: string;
  id?: string;
}

//
const Cursor = ({ color, x, y, id = undefined }: CursorProps) => {
  const useName = USERS.find((user) => user.id === id)?.name || id;

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 99999,
        transform: `translateX(${x}px) translateY(${y}px)`,
        transition: 'all .3s ease-out',
      }}
    >
      <svg width="24" height="36" viewBox="0 0 24 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.65376 12.3673H5.46026L5.31717 12.4976L0.500002 16.8829L0.500002 1.19841L11.7841 12.3673H5.65376Z"
          fill={color}
        />
      </svg>

      <P16 $margin="-20px 0 0 0" $backgroundColor={color} $padding="0 8px">
        {useName}
      </P16>
    </div>
  );
};

export const LiveCursors = ({ children }: { children: React.ReactNode }) => {
  const updateMyPresence = useUpdateMyPresence();

  const others = useLiveCursors();
  const cursorsToDisplay = useCursorConnections();

  return (
    <div
      onPointerMove={(event) => {
        updateMyPresence({
          cursor: {
            x: event.clientX,

            y: event.clientY,
          },
        });
      }}
      style={{
        width: '100%',
      }}
    >
      {children}
      {others.map(({ connectionId, id, presence }) => {
        if (!cursorsToDisplay.includes(connectionId)) return null;

        return (
          <Cursor
            key={connectionId}
            x={(presence.cursor as unknown as Cords)?.x}
            y={(presence.cursor as unknown as Cords)?.y}
            color={COLORS[connectionId % COLORS.length]}
            id={id}
          />
        );
      })}
    </div>
  );
};
